import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';

@Injectable({
  providedIn: 'root',
})
export class UrlImagesService {
  public getCompanyLogo(subdomain?: string | null, companyIconId?: string | null): URL | string {
    if (!subdomain || !companyIconId) {
      return 'assets/images/no-icon-job.svg';
    }

    return new URL(`${subdomain}/api/images/${companyIconId}`, environment.careerPageUrl);
  }
}
